import React, { useState, useCallback } from 'react';
import { prop } from 'ramda';
import { SmsVerificationStepType } from '@theme/js/components/main/SmsVerification';
import { STEPS_NAME, VERIFICATION_TYPES } from '@theme/js/components/main/SmsVerification/constants';
import { useTranslations } from '@core/js/hooks/i18n';
import { useUserSelector } from '@core/js/store/hooks';
import { TermsAndConditions } from '@theme/js/components/main/SmsVerification/components/TermsAndConditions/TermsAndConditions';

import style from '@theme/js/components/main/SmsVerification/index.scss';

const InitialStep = React.memo(({ setStep, type }: SmsVerificationStepType) => {
    const [isChecked, setIsChecked] = useState(true);
    const [isTermsOpened, setIsTermsOpened] = useState(false);
    const { cellphone } = useUserSelector(prop('userDetails'));
    const t = useTranslations('playtech.mobile.system.verification.');
    const iconCls = type === VERIFICATION_TYPES.DEFAULT ? style.mobileIcon : style.giftIcon;
    const postfix = type === VERIFICATION_TYPES.INCENT ? '.incent' : '';

    const handleButtonClick = useCallback(() => {
        setStep?.(STEPS_NAME.CODE);
    }, [setStep]);

    return (
        <>
            <div className={`${style.icon} ${iconCls}`}></div>
            <div className={style.message}>{t(`initial.message${postfix}`)}</div>
            <div className={style.description}>{t('initial.description')}</div>
            <div className={style.phoneNumber}>{cellphone}</div>
            <div className={style.link} onClick={() => setStep?.(STEPS_NAME.CHANGE_NUMBER)}>
                {t('changePhone')}
            </div>

            {type === VERIFICATION_TYPES.INCENT && (
                <>
                    <div className={style.termsContainer}>
                        <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={() => setIsChecked((oldIsChecked) => !oldIsChecked)}
                        />
                        <span className={style.termsTitle}>
                            {t('initial.terms1')}
                            &nbsp;<span onClick={() => setIsTermsOpened(true)} className={style.boldLink}>{t('initial.terms2')}</span>&nbsp;
                            {t('initial.terms3')}
                        </span>
                    </div>

                    {isTermsOpened && <TermsAndConditions onClose={() => setIsTermsOpened(false)} /> }
                </>
            )}

            <button onClick={handleButtonClick} disabled={!isChecked} className={style.verificationButton}>
                {t('initial.submit')}
            </button>
        </>
    );
});

export default InitialStep;
